import React, { useState } from "react";
import DatePicker from "react-date-picker";
import { firestore } from "../../firebase/config";
// import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { getDateInFormat } from "../utilities/Utils";
import GetReferenceDetails from "../GetReferenceDetails";
import DonationReportDetails from "./ReportDetails";
import { useHistory } from "react-router-dom";
import { TiArrowBack } from "react-icons/ti";
import "./DateRangeDonationReport.css";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import {
  getFirestore,
  collectionGroup,
  query,
  where,
  getDocs,
  doc,
  collection,
  getDoc,
} from "firebase/firestore";
const columns = [
  {
    selector: (row) => row.donorId,
    name: "Donor Id",
  },
  {
    selector: (row) => row.donorName,
    name: "Donor Name",
    sortable: true,
  },
  {
    selector: (row) => row.donationId,
    name: "Donation Id",
  },
  {
    name: "Receipt No",
    selector: (row) => row.donationReceiptNo,
  },
  {
    selector: (row) => row.donationDate,
    name: "Donation Date",
  },
  {
    selector: (row) => row.amount,
    name: "Amount",
  },
  {
    selector: (row) => row.bank,
    name: "Bank",
  },
  {
    selector: (row) => row.bankRef,
    name: "Bank Reference",
  },
  {
    selector: (row) => row.bankRefDate,
    name: "Bank Reference Date",
  },
  {
    selector: (row) => row.mode,
    name: "Mode",
  },
  {
    selector: (row) => row.onRecord,
    name: "On Record",
  },
  {
    selector: (row) => row.receivedThroughWebsite,
    name: "Received Through Website",
  },
  {
    selector: (row) => row.csrDonation,
    name: "CSR Donation",
  },
  {
    selector: (row) => row.collectedBy,
    name: "Reference",
  },
  {
    selector: (row) => row.trust,
    name: "To Trust",
  },
];
function DateRangeDonationReport() {
  const [isLoading, setIsLoading] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const [donationDetails, setDonationDetails] = useState(null);
  const [exportObj, setExportObject] = useState(null);
  const [foundNoRecord, setFoundNoRecord] = useState(false);
  const [totalDonationAmount, setTotalDonationAmount] = useState(0);
  const history = useHistory();
  // const [columnData, setCoulmnData] = useState(columns);
  const updateFromDate = (date) => {
    setFromDate(date);
    if (toDate !== null) setToDate(null);
  };
  /**
   * Retrieves the full name of a donor based on the provided reference.
   * @param {string} ref - The reference to the donor document.
   * @returns {Promise<string|null>} - A promise that resolves with the donor's full name or null if the document doesn't exist.
   */
  async function getDonorName(ref) {
    try {
      const collectionDonor = collection(firestore, "donors");
      const docRef = doc(collectionDonor, ref);
      const snapShot = await getDoc(docRef);

      if (snapShot.exists()) {
        return snapShot.data().fullName;
      } else {
        return null; // Return null if the document doesn't exist
      }
    } catch (e) {
      console.log(`Error in DateRangeDonationReport.jsx getDonorName: ${e}`);
      console.log(e);
      return null;
    }
  }

  const prepareExportObject = async (donationArray) => {
    const newArray = [];
    for (const dataObjEach of donationArray) {
      const newObj = {};
      let donorId = dataObjEach.donorId;
      let donorName = await getDonorName(donorId);

      if (donorName !== null) dataObjEach.donorName = donorName;
      if (dataObjEach.collectedByOrig !== "Self") {
        let collectedById = dataObjEach.collectedByOrig;
        let donorCollecorName = await getDonorName(collectedById);

        if (donorCollecorName !== null)
          dataObjEach.collectedBy = donorCollecorName;
      }
      for (const key in dataObjEach) {
        if (key !== "collectedByOrig") {
          newObj[key] = dataObjEach[key];
        }
      }
      newArray.push(newObj);
    }
    setExportObject(newArray);
  };
  const searchDonations = async () => {
    setIsLoading(true);
    setTotalDonationAmount(0); //Reset to zero
    setDonationDetails(null);
    setFoundNoRecord(false);

    toDate.setHours(23);
    const db = getFirestore();
    const donationArray = [];
    try {
      const q = query(
        collectionGroup(db, "donations"),
        where("date", ">=", fromDate),
        where("date", "<=", toDate),
        where("type", "==", "Donation")
      );

      const querySnapShot = await getDocs(q);

      if (!querySnapShot.empty) {
        querySnapShot.forEach((donation) => {
          const donationData = donation.data();
          const donationReceiptNo = donationData.receiptNo;
          const donorId = donation.ref.parent.parent.id;

          setTotalDonationAmount(
            (prevAmount) => prevAmount + parseInt(donationData.amount)
          );

          donationArray.push({
            donationId: donation.id,
            donorName: <GetReferenceDetails refId={donorId} needLink={true} />,
            amount: donationData.amount,
            donationDate: getDateInFormat(
              donationData.date.toDate().toString()
            ),
            bank: donationData.bank,
            bankRef: donationData.bankRef,
            bankRefDate: donationData.bankRefDate
              ? getDateInFormat(donationData.bankRefDate.toDate().toString())
              : "",
            trust: donationData.trust,
            mode: donationData.mode,
            donationReceiptNo: donationReceiptNo || "Not Available",
            donorId: donorId,
            onRecord: donationData.onRecord ? "Yes" : "No",
            csrDonation: donationData.csrDonation ? "Yes" : "No",
            receivedThroughWebsite: donationData.receivedThroughWebsite
              ? "Yes"
              : "No",
            collectedByOrig: donationData.collectedBy,
            collectedBy:
              donationData.collectedBy === "Self" ? (
                donationData.collectedBy
              ) : (
                <GetReferenceDetails
                  refId={donationData.collectedBy}
                  needLink={false}
                />
              ),
          });
        });
        setDonationDetails(donationArray);
        prepareExportObject(donationArray);
      } else {
        setFoundNoRecord(true);
      }
    } catch (error) {
      console.error("Error fetching donation data:", error);
      alert("Failed to fetch report data. Please check your network connection or permissions.");
    }

    setIsLoading(false);
  }; //End of searchDonations

  const handleBackButton = (e) => {
    history.push("/donorreporthome");
    e.preventDefault();
  };

  const paginationComponentOptions = { selectAllRowsItem: true };
  return (
    <>
      <div className="card p-1 mb-1">
        <button
          className="btn btn-link"
          id="backButton"
          onClick={handleBackButton}
        >
          <TiArrowBack />
          Back to Report Home Page
        </button>
        <div className="justify-content-center d-flex">
          <h2>Donations Report</h2>
        </div>
      </div>{" "}
      <div className="card p-1 mb-1">
        <div className="justify-content-center d-flex">
          <form
            className="align-items-center"
            onSubmit={(e) => {
              e.preventDefault();
              searchDonations();
            }}
          >
            <label className="me-2" htmlFor="fromDate">
              From:
            </label>
            <DatePicker
              value={fromDate}
              id="fromDate"
              name="fromDate"
              onChange={(date) => updateFromDate(date)}
              format="dd-MMM-yyyy"
              maxDate={new Date()}
              className="ms-1 me-1"
            />
            <label className="ms-4 me-2" htmlFor="toDate">
              To:
            </label>
            <DatePicker
              value={toDate}
              id="toDate"
              name="toDate"
              onChange={(date) => setToDate(date)}
              format="dd-MMM-yyyy"
              disabled={fromDate === null}
              minDate={fromDate}
              maxDate={new Date()}
              className="ms-1 me-1"
            />
            {/* <label className="ml-4 mr-2" htmlFor="trust">
              Trust:
            </label> */}
            {!isLoading && (
              <button
                type="submit"
                className="ps-1 btn btn-primary ms-4"
                disabled={toDate === null}
              >
                Search
              </button>
            )}
            {isLoading && (
              <Button variant="primary" disabled>
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                Getting Data...
              </Button>
            )}
          </form>
        </div>
      </div>
      <div className="card border-top-0 rounded-0">
        <div className="card-body py-2 justify-content-center d-flex">
          <div className="card-title font-weight-bold m-0">
            {donationDetails !== null
              ? `Report`
              : foundNoRecord
              ? `No Record Found`
              : ``}
          </div>
        </div>

        {donationDetails !== null &&
          donationDetails.length > 0 &&
          !isLoading && (
            <>
              <div className="card-body py-2 justify-content-center d-flex">
                No of records: {donationDetails.length}
              </div>
              <div className="card-body py-2 justify-content-center d-flex">
                Total Donation Amount: {totalDonationAmount}
              </div>

              <DonationReportDetails
                data={donationDetails}
                columns={columns}
                keyField={"donationId"}
                pagination={true}
                paginationComponentOptions={paginationComponentOptions}
                filename="DateRangeDonationReport"
                exportObject={exportObj}
              />
            </>
          )}
      </div>
    </>
  );
}

export default DateRangeDonationReport;
